import { Button } from 'antd';
import React from 'react';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import styles from "./error.module.scss";

export const ErrorScreen: React.ComponentType<FallbackProps> = ({
  error,
  resetErrorBoundary
}) => {
  const { t } = useTranslation();

  // Log the error essentials to the console so prod-only failures are
  // debuggable without asking the reporting user for a stack trace
  // Console only so the user-facing UI below is unchanged
  // The raw error object is not dumped so arbitrary attached data cannot leak
  React.useEffect(() => {
    try {
      /* eslint-disable no-console */
      console.error("[ErrorScreen] Unhandled error caught by ErrorBoundary");
      console.error("[ErrorScreen] message:", error?.message);
      console.error("[ErrorScreen] stack:", error?.stack);
      console.error(
        "[ErrorScreen] componentStack:",
        (error as any)?.componentStack
          ?? (error as any)?.cause?.componentStack
      );
      /* eslint-enable no-console */
    } catch {
      // swallow so diagnostic logging never itself throws
    }
  }, [error]);

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div className={styles.error_container}>
      <h2>{ t('error.title') }</h2>
      {error?.message && <p>Error: {error.message}</p>}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Button onClick={resetErrorBoundary}>Try again</Button>
        <Button onClick={refreshPage}>Refresh</Button>
      </div>
    </div>
  );
};
